import { render, staticRenderFns } from "./grads.vue?vue&type=template&id=8481dd62&scoped=true"
import script from "./grads.vue?vue&type=script&setup=true&lang=ts"
export * from "./grads.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./grads.vue?vue&type=style&index=0&id=8481dd62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8481dd62",
  null
  
)

export default component.exports